module.exports = __webpack_public_path__ + "img/crb-gauge-form-image.035cafd5.png";